const state = () => ({
  mini: false,
  toggle: false
});

const getters = {
  getMini: state => state.mini,
  getToggle: state => state.toggle
};

const mutations = {
  setMini(state, data) {
    state.mini = data;
  },
  toggleMini(state, data) {
    state.mini = data;
    state.toggle = true;
  }
};

const actions = {};

export default { mutations, state, actions, getters };
